import { render, staticRenderFns } from "./UsersPurchases.vue?vue&type=template&id=4efee4f3"
import script from "./UsersPurchases.vue?vue&type=script&lang=js"
export * from "./UsersPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports